module.exports = __webpack_public_path__ + "static/media/img-025.cfd1888b.png";